import { IColumnConfig } from '../../shared/interfaces/table.interface';

const columns :IColumnConfig[] = [
  {
    id: 'channel',
    label: 'Channel',
    visible: true,
  },
  {
    id: 'channelType',
    label: 'Channel Type',
    visible: true,
  },
  {
    id: 'warehouseGroup',
    label: 'Warehouse Group',
    visible: true,
  },
  {
    id: 'remarks',
    label: 'Remarks',
    visible: true,
  },
  {
    id: 'posChannel',
    label: 'Internal Sales Channel',
    visible: true,
  },
  {
    id: 'pullStocks',
    label: 'Get Orders',
    visible: true,
  },
  {
    id: 'pushStocks',
    label: 'Push Orders',
    visible: true,
  },
  {
    id: 'pushStocksToChannel',
    label: 'Push Stocks To Channel',
    visible: true,
  },
  {
    id: 'tags',
    label: 'Tags',
    visible: true,
  },
  {
    id: 'active',
    label: 'Active',
    visible: true,
  },
];

export const ChannelTableConfig = {
  columns,
};
